var _defs, _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 236.5 289.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{stroke:#a77b35;}.cls-1,.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-1{fill:url(#Degradado_sin_nombre_10);}.cls-2{fill:url(#Degradado_sin_nombre_10-2);}.cls-3{fill:url(#Degradado_sin_nombre_10-3);}.cls-4{fill:url(#Degradado_sin_nombre_10-4);}.cls-10,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#a87b35;}.cls-5{fill:url(#Degradado_sin_nombre_10-5);}.cls-6{fill:url(#Degradado_sin_nombre_10-6);}.cls-7{fill:url(#Degradado_sin_nombre_10-7);}.cls-8{fill:url(#Degradado_sin_nombre_10-8);}.cls-9{fill:url(#Degradado_sin_nombre_10-9);}.cls-10{fill:url(#Degradado_sin_nombre_10-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: 86.22,
    y1: 288.71,
    x2: 86.22,
    y2: 251.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a77a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#af8541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c9a868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ddc487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ebd79c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f4e3aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f7e7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a77a35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-2",
    x1: 117.44,
    y1: 288.19,
    x2: 117.44,
    y2: 261.12,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-3",
    x1: 136.09,
    y1: 287.51,
    x2: 136.09,
    y2: 252.46,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-4",
    x1: 153.96,
    y1: 288.19,
    x2: 153.96,
    y2: 252.46,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-5",
    x1: 0.5,
    y1: 118.25,
    x2: 236,
    y2: 118.25,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-6",
    x1: 115.03,
    y1: 84.81,
    x2: 131,
    y2: 84.81,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-7",
    x1: 111.34,
    y1: 70.19,
    x2: 134.69,
    y2: 70.19,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-8",
    x1: 104.22,
    y1: 60.08,
    x2: 141.81,
    y2: 60.08,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-9",
    x1: 95.98,
    y1: 50.29,
    x2: 150.94,
    y2: 50.29,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-10",
    x1: 41.82,
    y1: 135.5,
    x2: 194.68,
    y2: 135.5,
    xlinkHref: "#Degradado_sin_nombre_10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.88,274.68h7.64a7.32,7.32,0,0,1-.65,3.05,8.07,8.07,0,0,1-1.8,2.53A8.5,8.5,0,0,1,90.39,282a8.67,8.67,0,0,1-3.31.63,8.21,8.21,0,0,1-4.32-1.1,9.37,9.37,0,0,1-3-2.84A12.55,12.55,0,0,1,78,274.76a17.73,17.73,0,0,1-.55-4.3q0-6.21,2.63-9.47a8.57,8.57,0,0,1,7-3.26,8.8,8.8,0,0,1,2.83.47,8.51,8.51,0,0,1,2.42,1.25,6.87,6.87,0,0,1,1.72,1.85,5.53,5.53,0,0,1,.83,2.27h7.29a11.34,11.34,0,0,0-1.43-4.77,12.46,12.46,0,0,0-3.22-3.73,15.36,15.36,0,0,0-4.67-2.45,18.21,18.21,0,0,0-5.74-.89,17.67,17.67,0,0,0-7.38,1.44,15,15,0,0,0-5.3,3.94A17,17,0,0,0,71.26,263a23.09,23.09,0,0,0-1.09,7.17,22.42,22.42,0,0,0,1.09,7,18.75,18.75,0,0,0,3.14,5.94,15.8,15.8,0,0,0,4.94,4.12,13.59,13.59,0,0,0,6.47,1.54,15.34,15.34,0,0,0,6.33-1.23,8.21,8.21,0,0,0,4-3.41l.16,3.44h6V268.89H87.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,264.8a11.62,11.62,0,0,0-4.07-2.71,14.11,14.11,0,0,0-5.39-1,14.5,14.5,0,0,0-5.47,1,11.63,11.63,0,0,0-4.12,2.74,12,12,0,0,0-2.62,4.29,17.32,17.32,0,0,0,0,11,11.34,11.34,0,0,0,6.68,7.05,15.63,15.63,0,0,0,10.92,0,11.33,11.33,0,0,0,4.09-2.74,12.27,12.27,0,0,0,2.6-4.26,16.27,16.27,0,0,0,.9-5.57,16.51,16.51,0,0,0-.9-5.59A11.91,11.91,0,0,0,127,264.8Zm-9.43,17.7q-6.18,0-6.18-7.82t6.18-7.77q6.18,0,6.18,7.77T117.55,282.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.72,
    y: 252.46,
    width: 6.75,
    height: 35.04
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.68,252.46v12.73a8.88,8.88,0,0,0-7.59-4,9.93,9.93,0,0,0-4.44,1,9.27,9.27,0,0,0-3.3,2.74,12.7,12.7,0,0,0-2,4.19,19.14,19.14,0,0,0-.7,5.35,18.82,18.82,0,0,0,.83,5.79,13.3,13.3,0,0,0,2.29,4.33,9.84,9.84,0,0,0,3.48,2.71,10.59,10.59,0,0,0,4.47.94,7.78,7.78,0,0,0,7.11-3.81l.05,3.13h6.5v-35Zm-1.38,28.17a5,5,0,0,1-4.08,2,5,5,0,0,1-4.15-2.16,9.14,9.14,0,0,1-1.61-5.61q0-7.93,5.82-7.93,5.66,0,5.66,8.35A8.24,8.24,0,0,1,158.3,280.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.25.5A117.76,117.76,0,1,0,236,118.26,117.75,117.75,0,0,0,118.25.5Zm0,222.81a105.06,105.06,0,1,1,105.06-105A105.06,105.06,0,0,1,118.25,223.31Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 123.02,
    cy: 84.81,
    r: 7.99
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M112.28,69.68a3.2,3.2,0,0,0,4.53,4.53,8.79,8.79,0,0,1,12.42,0,3.2,3.2,0,1,0,4.52-4.52,15.2,15.2,0,0,0-21.47,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M105.16,61a3.2,3.2,0,0,0,4.53,4.53,18.87,18.87,0,0,1,26.66,0A3.2,3.2,0,1,0,140.88,61a25.28,25.28,0,0,0-35.72,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.91,53.05a3.2,3.2,0,1,0,4.53,4.52,31.18,31.18,0,0,1,44,0A3.2,3.2,0,1,0,150,53.05a37.6,37.6,0,0,0-53.09,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M189.78,129.94l-35.26-39a19,19,0,0,0-14.07-6.24H107A6.32,6.32,0,0,0,100.64,91v21.81l-8.19-9.06A57.48,57.48,0,0,0,57.76,85.38a5.17,5.17,0,0,0,0-.57,8,8,0,1,0-8,8h0a6,6,0,0,0-4.54,5.79v19.94h6.25a3.6,3.6,0,1,1-3.6,3.6H41.82a9.74,9.74,0,0,0,9.88,9.74,9.87,9.87,0,0,0,9.6-9.6,9.74,9.74,0,0,0-9.74-9.88V92.6h0a7.91,7.91,0,0,0,3.62-1.87l42.08,46.56H41.82v23.76a12.63,12.63,0,0,0,12.64,12.63h6.18a20.49,20.49,0,0,0,41,0h33.25a20.5,20.5,0,1,0,41,0H182a12.63,12.63,0,0,0,12.64-12.63v-18.4A19,19,0,0,0,189.78,129.94ZM81.13,181.51a8,8,0,1,1,8-8A8,8,0,0,1,81.13,181.51Zm74.24.16a8,8,0,1,1,8-8A8,8,0,0,1,155.37,181.67Zm-31.91-44.38V104h13a6.34,6.34,0,0,1,4.75,2.15l27.38,31.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipGold);
export default __webpack_public_path__ + "static/media/membershipGold.520d99cd77f66644f82b9a38f9d10522.svg";
export { ForwardRef as ReactComponent };